(function () {
  'use strict';

  angular
    .module('ecs')
    .config(config);

  function config() {
  }
}());
